import React from 'react';
import { renderIcon } from '../../../../SprintDetail/FlowchartView/utils/renderIcon';
import { DocIcon } from '../icons';

/**
 * DocColumn — third column showing active document search results (titles only).
 */
const DocColumn = ({ documents, searchQuery, onDocClick }) => {
  return (
    <div className="unified-search-popup__column">
      <div className="unified-search-popup__column-header">
        <DocIcon size={12} />
        <span>Documents</span>
        <span className="unified-search-popup__count">{documents.length}</span>
      </div>
      <div className="unified-search-popup__list">
        {documents.length > 0 ? (
          documents.map((doc) => (
            <div
              key={doc.id}
              className="unified-search-popup__item unified-search-popup__item--doc"
              onClick={() => onDocClick(doc)}
            >
              <span className="unified-search-popup__doc-icon">
                {renderIcon(doc.icon, { size: '18px', fallback: <span>📄</span> })}
              </span>
              <div className="unified-search-popup__item-main">
                <span className="unified-search-popup__item-name">
                  {doc.title || 'Untitled Doc'}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="unified-search-popup__empty">
            {searchQuery ? 'No documents found' : 'Type to search documents'}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocColumn;
